import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PendingProductCreated from "../modals/PendingProductCreated";

export default function UpdatePendingProduct({ pendingProdId, changeView }) {
  const [name, setName] = useState("");
  const [nameErr, setNameErr] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionErr, setDescriptionErr] = useState("");
  const [price, setPrice] = useState("");
  const [priceErr, setPriceErr] = useState("");

  const navi = useNavigate();
  const [updateComplete, setUpdateComplete] = useState(false);
  const [pendingClubId, setPendingClubId] = useState("");
  const [token, setToken] = useState(0);
  const [tokenErr, setTokenErr] = useState("");
  const [interval, setInterval] = useState("month");
  const [isLoading, setIsLoading] = useState(false);
  const [product, setProduct] = useState([]);

  const { user, dispatch } = useAuthContext();
  const [staticName, setStaticName] = useState("");

  const handlePriceChange = (e) => {
    let inputValue = e.target.value.replace(/[^\d.]/g, "");
    const decimalIndex = inputValue.indexOf(".");
    if (decimalIndex !== -1) {
      inputValue =
        inputValue.substring(0, decimalIndex + 1) +
        inputValue.substring(decimalIndex + 1).replace(".", "");
      inputValue = inputValue.substring(0, decimalIndex + 3);
    }
    setPrice(inputValue);
  };

  const setInitialPrice = (rawPrice) => {
    const pounds = (parseInt(rawPrice, 10) / 100).toFixed(2);
    setPrice(pounds);
  };

  const formatString = (input) => {
    input = String(input);
    if (!input.includes(".")) {
      return input + "00";
    }
    return input;
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const prodResponse = await axios.get(
        `${ApiConnectionString}/api/pendingproduct/${pendingProdId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      setProduct(prodResponse.data);
      setName(prodResponse.data.name);
      setDescription(prodResponse.data.description);
      setStaticName(prodResponse.data.name);
      setInitialPrice(prodResponse.data.price);
      setPendingClubId(prodResponse.data.pendingClubId);
      setInterval(prodResponse.data.interval);
      setToken(prodResponse.data.classToken);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;
    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setNameErr("");
    setDescriptionErr("");
    setPriceErr("");
    setTokenErr("");
    setIsLoading(true);

    let error = false;
    const formattedPrice = formatString(price);

    if (parseInt(formattedPrice.toString().replace(".", ""), 10) < 100) {
      setPriceErr("too low");
      error = true;
    }

    if (product.recurring) {
      switch (interval) {
        case "month":
          if (price > 250) {
            setPriceErr("Monthly subscriptions must not exceed £250");
            error = true;
          }
          break;
        case "week":
          if (price > 75) {
            setPriceErr("Weekly subscriptions must not exceed £75");
            error = true;
          }
          break;
        case "year":
          if (price > 2500) {
            setPriceErr("Yearly subscriptions must not exceed £2500");
            error = true;
          }
          break;
      }
    } else {
      if (price > 250) {
        setPriceErr("Price must not exceed £250");
        error = true;
      }
    }

    if (error) {
      setIsLoading(false);
      return;
    }

    const editProduct = {
      pendingProdId,
      pendingClubId,
      name,
      description,
      price: parseInt(formattedPrice.toString().replace(".", ""), 10),
      token,
      interval,
      recurring: product.recurring,
    };

    try {
      const response = await axios.put(
        `${ApiConnectionString}/api/pendingproduct`,
        editProduct,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      if (response.status === 200) {
        setUpdateComplete(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="container">
      <div className="col bg-white mx-5 my-2 p-0 ">
        <div className="blueBanner">
          <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
            Edit Product : {staticName}
          </p>
        </div>

        <div className="d-flex justify-content-end">
          <button
            onClick={() => changeView("mainPage")}
            className="settings-menu-button"
          >
            Go Back
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <table className="m-2">
            <tbody>
              <tr>
                <th className="red-text">Title:</th>
                <td>
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </td>
              </tr>
              {nameErr && <p className="text-danger">{nameErr}</p>}

              <tr>
                <th className="red-text">Description:</th>
                <td>
                  <input
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </td>
              </tr>

              {descriptionErr && (
                <p className="text-danger">{descriptionErr}</p>
              )}

              <tr>
                <th className="red-text">Cost:</th>
                <td className="d-flex align-items-center">
                  <span className="me-1">£</span>
                  <input
                    type="text"
                    value={price}
                    onChange={handlePriceChange}
                  />
                </td>
              </tr>

              {priceErr && <p className="text-danger">{priceErr}</p>}

              {!product.recurring ? (
                <tr>
                  <th className="red-text">Classes:</th>
                  <td>
                    <input
                      type="number"
                      value={token}
                      onChange={(e) => setToken(e.target.value)}
                    />
                  </td>
                </tr>
              ) : (
                <tr>
                  <th className="red-text">Interval:</th>
                  <td>
                    <select
                      id="interval"
                      name="interval"
                      value={interval}
                      onChange={(e) => setInterval(e.target.value)}
                    >
                      <option value="month">Month</option>
                      <option value="week">Week</option>
                      <option value="year">Year</option>
                    </select>
                  </td>
                </tr>
              )}

              {tokenErr && <p className="text-danger">{tokenErr}</p>}
            </tbody>
          </table>

          <button className="saveChanges-button mx-4">Update</button>
        </form>
      </div>

      {updateComplete && <PendingProductCreated changeView={changeView} />}
    </div>
  );
}
